var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeEmptyFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C4.3125 0 3.75 0.5625 3.75 1.25V18.75C3.75 19.4375 4.3125 20 5 20H17.5C18.1875 20 18.75 19.4375 18.75 18.75V5L13.75 0H5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H18.75L13.75 0V3.75C13.75 4.4375 14.3125 5 15 5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.75L15 5H18.75V8.75Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25C16.25 16.5938 15.9688 16.875 15.625 16.875H1.875C1.53125 16.875 1.25 16.5938 1.25 16.25V10C1.25 9.65625 1.53125 9.375 1.875 9.375H15.625C15.9688 9.375 16.25 9.65625 16.25 10V16.25Z",
    fill: "#B0B7BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.875H3.75V17.5H15.625C15.9688 17.5 16.25 17.2188 16.25 16.875V16.25C16.25 16.5938 15.9688 16.875 15.625 16.875Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeEmptyFile);
export default __webpack_public_path__ + "static/media/large_empty_file.f22f7718649fe31875bcf2b1aa72f11e.svg";
export { ForwardRef as ReactComponent };